import * as yup from 'yup';
import sanitizeFilename from 'sanitize-filename';
import config from '@config/index';

/* Windows reserved device names */
const WINDOWS_RESERVED = [
  'con',
  'prn',
  'aux',
  'nul',
  ...Array.from({ length: 9 }, (_, i) => `com${i + 1}`),
  ...Array.from({ length: 9 }, (_, i) => `lpt${i + 1}`),
];

// eslint-disable-next-line no-control-regex
const ILLEGAL_CHARS = /[<>:"/\\|?*\u0000-\u001F]/; // ctrl chars + win invalid
const LEADING_SPACE_DOT = /^[. ]/;
const TRAILING_SPACE_DOT = /[. ]$/;

/** Re-usable Yup schema for any “filename‐like” field */
export const filenameStringSchema = (label = 'Name', max = config.ITEM_NAME_MAX_LENGTH) =>
  yup
    .string()
    /* we probably want to throw an error in case of leading/trailing spaces, instead of trimming */
    // .transform((v) => v?.trim() ?? '')
    .required(`${label} is required.`)
    .max(max, `${label} exceeds ${max} character limit.`)
    .test('no-illegal-chars', `${label} contains invalid characters (\\ / : * ? " < > |)`, (v) =>
      v ? !ILLEGAL_CHARS.test(v) : false
    )
    .test('no-leading-space-dot', `${label} may not start with a space or dot.`, (v) =>
      v ? !LEADING_SPACE_DOT.test(v) : false
    )
    .test('no-trailing-space-dot', `${label} may not end with a space or dot.`, (v) =>
      v ? !TRAILING_SPACE_DOT.test(v) : false
    )
    .test('not-reserved', `${label} is reserved.`, (v) => (v ? !WINDOWS_RESERVED.includes(v.toLowerCase()) : false))
    .test('sanitize-check', `${label} is not a valid filename.`, (v) => (v ? sanitizeFilename(v) === v : false));

export const getInvalidFilenameSegment = (relPath: string): string | null => {
  return (
    relPath
      .split('/')
      .filter(Boolean)
      .find((segment) => {
        try {
          filenameStringSchema('Filename').validateSync(segment);
          return false;
        } catch {
          return true;
        }
      }) ?? null
  );
};
